import { render, staticRenderFns } from "./CredenciamentoAcoesDespublicar.vue?vue&type=template&id=104fefb3&scoped=true"
import script from "./CredenciamentoAcoesDespublicar.vue?vue&type=script&lang=js"
export * from "./CredenciamentoAcoesDespublicar.vue?vue&type=script&lang=js"
import style0 from "./CredenciamentoAcoesDespublicar.vue?vue&type=style&index=0&id=104fefb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104fefb3",
  null
  
)

export default component.exports